import { useCallback } from "react";
import { useSelector } from "react-redux";
import { firebaseApp } from "../firebase";
import { getAuth } from "firebase/auth";
import { IState } from "../types";

const useDownloadRawVideo = () => {
  const auth = getAuth(firebaseApp);
  const selectedWorkspace = useSelector(
    (state: IState) => state.user.selectedWorkspace
  );

  const downloadRawVideo = useCallback(
    async (transcriptId: string, fileName: string) => {
      try {
        const token = await auth.currentUser?.getIdToken(true);

        if (!token) {
          throw new Error("User not authenticated.");
        }

        const backendUrl = new URL(
          `${process.env.REACT_APP_BACKEND_ENDPOINT}/utils/download/raw-video`
        );

        backendUrl.searchParams.append("workspaceId", selectedWorkspace.id);
        backendUrl.searchParams.append("transcriptId", transcriptId);
        backendUrl.searchParams.append("token", token);

        const response = await fetch(backendUrl.toString());
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.error ||
              `Failed to get download link. Status: ${response.status}`
          );
        }
        const { downloadUrl, fileName } = await response.json();

        const a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadUrl;

        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (e) {
        throw e;
      }
    },
    [auth.currentUser, selectedWorkspace.id]
  );

  return { downloadRawVideo };
};

export default useDownloadRawVideo;
